import { Heading } from '@doist/marketist'

import slugifyText from 'services/slugifyText'

import css from './ImageHeading.module.css'

export type ImageHeadingProps = {
    title: string
    image: { src: string }
}

export function ImageHeading({ title, image }: ImageHeadingProps) {
    const id = slugifyText(title)
    return (
        <div className={css.imageHeading}>
            <Heading id={id} level="2">
                {title}
            </Heading>
            {image && <img src={image.src} alt="" />}
        </div>
    )
}
